
    var riot = require('riot')
    //src: starling/src/tags/map-menu.html
riot.tag2('map-menu',
  '<ul ref="mainMenu" class="floating-menu_list"> <li class="floating-menu_item" onclick="{openNewMapPage}" onmouseenter="{delayedHideSubMenus}" data-track="Map Menu" data-track-action="Create-Map" data-track-label="Map"> <i class="fa fa-map floating-menu_icon" aria-hidden="true"></i> <span class="floating-menu_label">New map</span> </li> <li class="floating-menu_item" onclick="{openTemplatesModal}" onmouseenter="{delayedHideSubMenus}" data-track="Map Menu" data-track-action="Templates-Modal" data-track-label="Map"> <svg class="floating-menu_icon"> <use xlink:href="#templates-icon"></use> </svg> <span class="floating-menu_label">Start from template</span> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item" onclick="{openShareModal}" onmouseenter="{delayedHideSubMenus}" data-track="Map Menu" data-track-action="Share-Map" data-track-label="Map"> <i class="fa fa-users floating-menu_icon" aria-hidden="true"></i> <span class="floating-menu_label">Share</span> </li> <li if="{showPresentOption()}" class="floating-menu_item" onclick="{beginPresentation}" onmouseenter="{delayedHideSubMenus}" data-track="Map Menu" data-track-action="Start-Presentation" data-track-label="Presentation"> <i class="material-icons floating-menu_icon">airplay</i> <span class="floating-menu_label">Present</span> </li> <li class="floating-menu_divider"></li> <li onclick="{makeCopy}" onmouseenter="{delayedHideSubMenus}" data-track="Map Menu" data-track-action="Copy-Map" data-track-label="Map"> <form ref="copyForm" class="floating-menu_item" method="POST" action="/maps/{canvas.access.publicIdentifier}/copy"> <i class="fa fa-clone floating-menu_icon" aria-hidden="true"></i> <span class="floating-menu_label">Duplicate Map</span> <input type="hidden" name="openMap" value="true"> </form> </li> <li if="{!canvas.isViewOnly()}" class="floating-menu_item" onclick="{openImportModal}" onmouseenter="{this.hideSubMenus}" data-track="Map Menu" data-track-action="Import-To-Map" data-track-label="Map"> <i class="material-icons floating-menu_icon">exit_to_app</i> <span class="floating-menu_label">Import</span> </li> <li class="floating-menu_item floating-menu_item--iconless" ref="exportOption" onmouseenter="{openExportMenu}"> <span class="floating-menu_label">Export map</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> </li> <li if="{canvas.store.access.role == \'owner\'}" class="floating-menu_divider"></li> <li if="{canvas.store.access.role == \'owner\'}" onclick="{deleteMap}" onmouseenter="{delayedHideSubMenus}" data-track="Map Menu" data-track-action="Delete-Map" data-track-label="Map"> <form ref="deleteForm" class="floating-menu_item" method="POST" action="/maps/{canvas.access.publicIdentifier}/delete/{canvas.access.editKey}"> <input if="{window.workspace}" type="hidden" name="workspacePublicIdentifier" riot-value="{window.workspace.publicIdentifier}"> <i class="material-icons floating-menu_icon">delete</i> <span class="floating-menu_label">Delete map</span> </form> </li> <li class="floating-menu_divider"></li> <li if="{window.config.inClassicExperience || window.config.inBetaExperience}" class="floating-menu_item {switchSitesMenuClass()}" onclick="{switchSites}" onmouseenter="{this.hideSubMenus}" data-track="Map Menu" data-track-action="Switch-Sites" data-track-label="{switchSitesEventLabel()}"> <i class="material-icons floating-menu_icon">{switchSitesMenuIcon()}</i> <span class="floating-menu_label">{switchSitesMenuLabel()}</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden" style="left: 0; padding-top: 4px; top: 100%;"', function(opts) {
'use strict';

var _this = this;

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _presentationUi = require('lib/presentation-ui');

var _presentationUi2 = _interopRequireDefault(_presentationUi);

var _constants = require('lib/constants');

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = this.opts.canvas;
this.canvas.mapMenuTag = this;
this.menuName = 'map-menu';

this.deleteMap = function (e) {
  e.preventDefault();
  e.stopPropagation();

  if (confirm('Are you sure you want to delete this map?')) {
    _this.refs.deleteForm.submit();
  } else {
    _this.hide();
  }

  return false;
};

this.openShareModal = function (e) {
  e.preventDefault();
  e.stopPropagation();

  _this.hide();
  _this.canvas.shareModal.show();
};

this.openImportModal = function (e) {
  e.preventDefault();
  e.stopPropagation();

  _this.hide();
  _this.canvas.importModal.show();
};

this.makeCopy = function (e) {
  e.preventDefault();
  e.stopPropagation();

  _this.hide();
  _this.refs.copyForm.submit();
};

this.openExportMenu = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'export',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.canvas.exportMenu.summon({
        spawnedFromElement: _this.refs.exportOption,
        origin: _this.menuName
      });
    }
  });
};

this.delayedHideSubMenus = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.hideSubMenus();
    }
  });
};

this.hideSubMenus = function (e) {
  _this.canvas.exportMenu.hide();
};

this.hide = function () {
  _this.root.classList.add('floating-menu--hidden');
  _this.hideSubMenus();
};

this.summon = function () {
  _this.update();
  _this.root.classList.remove('floating-menu--hidden');
};

this.openNewMapPage = function () {
  _this.hide();
  var url = '/maps/new';
  if (window.workspace) url = '/workspace/' + window.workspace.publicIdentifier + url;
  window.open(url, '_blank');
};

this.openTemplatesModal = function (e) {
  e.preventDefault();
  e.stopPropagation();

  _this.hide();
  _this.canvas.templatesModal.show();
};

this.showPresentOption = function () {
  var waypoints = _waypointsUi2.default.getWaypoints();
  if (waypoints && waypoints.length) {
    return true;
  }
  return false;
};

this.beginPresentation = function () {
  _this.canvas.waypointsTabTag.startPresentation();
};

this.switchSites = function () {
  _this.hide();
  $.ajax({
    url: '/api/user/site/toggle',
    method: 'post',
    data: {
      path: window.config.path
    },
    success: function success(result) {
      if (window.config.inBetaExperience && result && result.redirectUrl) {
        // force back to classic
        window.location.href = result.redirectUrl;
      } else {
        window.location.reload();
      }
    }
  });
};

this.switchSitesEventLabel = function () {
  if (window.config.inBetaExperience) {
    return 'Switch-Sites-Classic';
  } else if (window.config.inClassicExperience) {
    return 'Switch-Sites-Beta';
  }
};

this.switchSitesMenuLabel = function () {
  if (window.config.inBetaExperience) {
    return 'Use Plectica Classic';
  } else if (window.config.inClassicExperience) {
    return 'Use Plectica Beta';
  }
};

this.switchSitesMenuIcon = function () {
  if (window.config.inBetaExperience) {
    return 'home';
  } else if (window.config.inClassicExperience) {
    return 'new_releases';
  }
};

this.switchSitesMenuClass = function () {
  if (window.config.inBetaExperience) {
    return 'floating-menu_item--blue floating-menu_item--bold';
  } else if (window.config.inClassicExperience) {
    return 'floating-menu_item--orange floating-menu_item--bold';
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('map-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/map-menu.html
// module id = 603
// module chunks = 0